import React from 'react';
import PropTypes from 'prop-types';

import BreederProfileHelpModalContainer from 'dpl/containers/BreederProfile/Index/BreederProfileHelpModalContainer';
import Icon from 'dpl/common/components/Icon';
import DogSearchingSvg from 'dpl/common/components/DogSearching';

export default function BreederProfileHelpBox({
  breedName,
  breedNamePlural,
  modalIsOpen,
  toggleOff,
  toggleOn
}) {
  return (
    <div className="BreederProfileHelpBox">
      <button className="w-100 flex-l" onClick={toggleOn} type="button">
        <div className="mb4 mb0-lg mr6-lg d-none d-lg-block">
          <div className="stone-700 w6">
            <DogSearchingSvg />
          </div>
        </div>
        <div>
          <p className="mb3 primary f4 fw-medium">
            Adopting from a Shelter or Rescue
          </p>
          <p className="BreederProfileHelpBox__text mb4 black-90">
            Can&apos;t find the right pup for you? We encourage you to explore
            our Good Shelters and Rescues. Unlike our Good Breeders,
            irresponsible owners and unethical practices have led to the
            abandonment of many {breedNamePlural}. Get in touch with our team of
            experts who can help you find the right dog for you.
          </p>
          <div className="inline-flex items-center center link--primary fw-medium">
            <span className="mr2">Contact a specialist</span>
            <Icon name="lined-arrow-right" />
          </div>
        </div>
        {modalIsOpen && (
          <BreederProfileHelpModalContainer
            breedName={breedName}
            onClose={toggleOff}
          />
        )}
      </button>
    </div>
  );
}

BreederProfileHelpBox.propTypes = {
  breedName: PropTypes.string.isRequired,
  modalIsOpen: PropTypes.bool.isRequired,
  toggleOff: PropTypes.func.isRequired,
  toggleOn: PropTypes.func.isRequired,
  breedNamePlural: PropTypes.string.isRequired
};
